// extracted by mini-css-extract-plugin
export var customerAccount = "top-navigation-dr-module--customer-account--f6409";
export var footerEntry = "top-navigation-dr-module--footer-entry--e0a27";
export var header = "top-navigation-dr-module--header--fef04";
export var iconArrowDown = "top-navigation-dr-module--icon-arrow-down--97082";
export var iconArrowUp = "top-navigation-dr-module--icon-arrow-up--51abc";
export var iconLogin = "top-navigation-dr-module--icon-login--8672f";
export var iconLogout = "top-navigation-dr-module--icon-logout--f61d6";
export var iconUser = "top-navigation-dr-module--icon-user--ffaa7";
export var isCloseButton = "top-navigation-dr-module--is-close-button--2f0ab";
export var linkActive = "top-navigation-dr-module--link-active--262a4";
export var linkActiveBold = "top-navigation-dr-module--link-active-bold--fe4bd";
export var logo = "top-navigation-dr-module--logo--ab541";
export var mobileButton = "top-navigation-dr-module--mobile-button--4508f";
export var mobileMenuIsOpen = "top-navigation-dr-module--mobileMenuIsOpen--03873";
export var navigationWrapper = "top-navigation-dr-module--navigation-wrapper--27711";
export var subMenuOpen = "top-navigation-dr-module--sub-menu-open--a3c55";